export default __webpack_public_path__ + "static/media/jnh5.ad68929f.jpg";